/**
 * Fire a Google Analytics 4 custom event. Silent no-op if GA isn't initialised
 * (e.g. dev environment without REACT_APP_GA_MEASUREMENT_ID) — never throws.
 *
 * Usage:
 *   trackEvent("upload_start", { source: "drag_drop", size_kb: 42 });
 *   trackEvent("calculate_success", { vehicles: 3, cases: 27 });
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch {
    // Never let analytics break the app.
  }
}
